/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Modal,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../assets/styles/pages/User';
import Header from '../../components/Header';

// import icon svg
import { ReactComponent as IconLocation } from '../../assets/images/svg/user/icon_location.svg';
import { ReactComponent as IconLogout } from '../../assets/images/svg/user/icon_logout.svg';
import { ReactComponent as IconParceiro } from '../../assets/images/svg/user/icon_parceiro.svg';
import { ReactComponent as IconCallSuport } from '../../assets/images/svg/user/fale_conosco.svg';
import { ReactComponent as IconSugestionShop } from '../../assets/images/svg/user/icon_sugestao_estabelecimento.svg';
import { ReactComponent as IconUserEdit } from '../../assets/images/svg/user/icon_user-edit.svg';
import { ReactComponent as IconFreeDelivery } from '../../assets/images/svg/user/moto_pedido.svg';
import { ReactComponent as IconInfo } from '../../assets/images/svg/user/info.svg';
import { ReactComponent as IconCashBack } from '../../assets/images/svg/user/cashback.svg';

// import img
import imgLogo from '../../assets/images/svg/header/logo.png';
import imgFavorito from '../../assets/images/coracao_1.png';

import FooterMenuMain from '../../components/FooterMenuMain';
import { useSignInContext } from '../../providers/use-signin';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { useUserUpdateContext } from '../../providers/use-user-update';
import { removeStorege } from '../../helpers/db_storage';
import SelectStateAndCityV2, {
  SelectedDataProps,
} from '../../components/SelectStateAndCityV2';
import OptionMenu from '../../components/OptionMenu';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 8,
  p: 4,
  outline: 'none',
};

const MARGIN_BTN = '20px 12% 0 8%';

const User: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { signingOut, data } = useSignInContext();
  const userUpdateContext = useUserUpdateContext();

  const [phoneAdmFixed, setPhoneAdmFixed] = useState<any>();
  const [dataStateCity, setDataStateCity] = useState<any>();
  const [shopName, setShopName] = useState<string>('');
  const [openModalSuggestShop, setOpenModalSuggestShop] = useState(false);
  const [openModalSelectCityBeDelivery, setOpenModalSelectCityBeDelivery] =
    useState(false);
  const [openModalPartnerShop, setOpenModalPartnerShop] = useState(false);

  const handleToPage = (url: string, replace = false) => {
    if (replace) {
      return navigate(url, { replace: true });
    }
    return navigate(url);
  };

  const logout = () => {
    signingOut();
    handleToPage('/');
  };

  const handleGetLocalStorageDataStateCity = () => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );

    if (dataStorage) {
      setDataStateCity(dataStorage);
    }
  };

  const sendMsgWhatsApp = (msg: string, nrDDD: string, nrPhone: string) => {
    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_WHATSAPP}/send?phone=55${nrDDD}${nrPhone}&text=${msg}`;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  };

  const handleToLink = (url: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  };

  const getPhoneAdministrationFixed = async () => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getPhoneAdm(
        {
          nr_operacao: 17,
          dsCidade: dataStateCity?.dsCidade,
          idUsuario: data.user?.idUsuario,
        },
      );

      setPhoneAdmFixed(result.data);
    } catch (error) {
      toast.error(
        'Ocorreu um erro ao bucsar número do telefone do administrador',
      );
    }
  };

  const getPhoneAdministrationSelected = async (
    ds_city: string,
  ): Promise<any> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getPhoneAdm(
        {
          nr_operacao: 17,
          dsCidadeV2: ds_city,
          idUsuario: data.user?.idUsuario,
        },
      );

      return result.data;
    } catch (error) {
      toast.error(
        'Ocorreu um erro ao bucsar número do telefone do administrador',
      );
      return [];
    }
  };

  const handleBeDeliveryManApp = async (dataSelected: SelectedDataProps) => {
    if (
      dataSelected.dsCidade === undefined ||
      dataSelected.dsCidade === null ||
      dataSelected.dsCidade === ''
    ) {
      return;
    }

    // Se for franquia e selecionou a cidade , abrir whats do franqueado
    if (dataSelected.flgFranquia === '1') {
      const dataPhone = await getPhoneAdministrationSelected(
        dataSelected.dsCidade,
      );
      sendMsgWhatsApp(
        `Olá Mais Delivery de ${dataSelected.dsCidade}, gostaria de ser entregador do app.`,
        dataPhone[0].nrDDD,
        dataPhone[0].nrTelefone,
      );
      return;
    }

    // Se não for franquia e selecionou a cidade , abrir cadastro do entregador
    if (dataSelected.flgFranquia === '0') {
      handleToLink(
        'https://maisdeliveryapp.com.br/painel/auto_cadastro_entregador.php',
      );
    }
  };

  const handlePartnerShop = async (dataSelected: SelectedDataProps) => {
    if (
      dataSelected.dsCidade === undefined ||
      dataSelected.dsCidade === null ||
      dataSelected.dsCidade === ''
    ) {
      return;
    }

    // Se for franquia e selecionou a cidade , abrir whats do franqueado
    if (dataSelected.flgFranquia === '1') {
      const dataPhone = await getPhoneAdministrationSelected(
        dataSelected.dsCidade,
      );
      sendMsgWhatsApp(
        `Olá Mais Delivery de ${dataSelected.dsCidade} quero colocar meu estabelecimento no app como funciona?`,
        dataPhone[0].nrDDD,
        dataPhone[0].nrTelefone,
      );
      return;
    }

    // Se não for franquia e selecionou a cidade , abrir cadastro do entregador
    if (dataSelected.flgFranquia === '0') {
      handleToLink(
        'https://maisdeliveryapp.com.br/painel/auto_cadastro_loja.php',
      );
    }
  };

  useEffect(() => {
    userUpdateContext.cleanData();
    removeStorege('@mais/delivery/user/update');
    handleGetLocalStorageDataStateCity();
  }, []);

  useEffect(() => {
    if (dataStateCity?.dsCidade) {
      getPhoneAdministrationFixed();
    }
  }, [dataStateCity]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="User" />
      <CssBaseline />
      <Grid
        container
        item
        justifyContent="space-around"
        alignContent="center"
        className={classeStyle.gridUserData}
      >
        <Grid item xs={1} justifyContent="flex-end" container />
        <Grid item xs={7}>
          <p className={classeStyle.textWelecom}>Bem-vindo</p>{' '}
          <h5 className={classeStyle.textName}>{data.user?.dsNome}</h5>
        </Grid>
        <Grid item xs={3} justifyContent="center" container alignItems="center">
          <IconLogout style={{ cursor: 'pointer' }} onClick={logout} />
        </Grid>
      </Grid>
      <Grid
        container
        item
        justifyContent="center"
        alignContent="center"
        className={classeStyle.gridUserMenu}
      >
        <OptionMenu
          Icon={IconUserEdit}
          title="Editar Conta"
          fn={() => handleToPage('/dashboard/user/update')}
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          Icon={IconLocation}
          title="Meus
          Endereços"
          fn={() => handleToPage('/dashboard/user/address/list')}
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          Icon={IconCashBack}
          title="Programas de Fidelidade"
          fn={() => handleToPage('/fidelity')}
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          title="Meus Favoritos"
          fn={() => handleToPage('/dashboard/user/favorites')}
          marginBtn={MARGIN_BTN}
          img={imgFavorito}
        />
        <OptionMenu
          Icon={IconCallSuport}
          title="Fale Conosco"
          fn={() =>
            sendMsgWhatsApp(
              '',
              phoneAdmFixed[0].nrDDD,
              phoneAdmFixed[0].nrTelefone,
            )
          }
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          Icon={IconSugestionShop}
          title="Sugerir
          Estabelecimentos"
          fn={() => setOpenModalSuggestShop(true)}
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          Icon={IconParceiro}
          title="Seja um
          Estabelecimento Parceiro"
          fn={() => setOpenModalPartnerShop(true)}
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          Icon={IconFreeDelivery}
          title="Seja um
          Entregador do APP"
          fn={() => setOpenModalSelectCityBeDelivery(true)}
          marginBtn={MARGIN_BTN}
        />
        <OptionMenu
          Icon={IconInfo}
          title="Blog da Franquia"
          fn={() => handleToLink('https://www.maisdeliveryblog.com.br/')}
          marginBtn={MARGIN_BTN}
        />
        <Grid xs={12} container item justifyContent="center">
          <Button
            className={classeStyle.btnFranchisee}
            style={{ position: 'fixed' }}
            onClick={() =>
              handleToLink('https://www.maisdeliveryapp.com.br/landing-page/')
            }
          >
            <img
              src={imgLogo}
              alt="logo"
              className={classeStyle.logoBtnFranchisee}
            />
            <p className={classeStyle.textBtnFranchisee}>
              Quero ser um franqueado Mais Delivery!
            </p>
          </Button>
        </Grid>
      </Grid>
      <FooterMenuMain />
      <Modal
        open={openModalSuggestShop}
        onClose={() => setOpenModalSuggestShop(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal}>
          <>
            <Grid
              container
              item
              textAlign="center"
              justifyContent="center"
              xs={12}
              className={classeStyle.content}
            >
              <h3 className={classeStyle.title}>Sugerir estabelecimento</h3>
            </Grid>
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              style={{ backgroundColor: '#f9f9f9' }}
              boxShadow="24"
              borderRadius="0 0 25px 25px"
            >
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h6"
                className={classeStyle.titleModal}
                style={{
                  fontWeight: '500',
                  width: '100%',
                  textAlign: 'center',
                  fontSize: '0.9rem',
                }}
              >
                Qual o nome da sua sugestão de estabelecimento?
              </Typography>
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className={classeStyle.textModal}
              >
                <input
                  type="text"
                  className={classeStyle.inputText}
                  placeholder="Digite seu nome do estabeleciomento"
                  value={shopName}
                  name="dsNome"
                  onChange={(e) => setShopName(e.target.value)}
                />
              </Typography>
              <Button
                className={classeStyle.btnModal}
                onClick={() =>
                  sendMsgWhatsApp(
                    `Olá Mais Delivery de ${dataStateCity?.dsCidade} não encontrei o estabelecimento *${shopName}* no app. Fica a dica ;)`,
                    phoneAdmFixed[0].nrDDD,
                    phoneAdmFixed[0].nrTelefone,
                  )
                }
                variant="contained"
              >
                Confirmar
              </Button>
            </Grid>
          </>
        </Box>
      </Modal>
      <SelectStateAndCityV2
        isOpen={openModalSelectCityBeDelivery}
        onClose={() => setOpenModalSelectCityBeDelivery(false)}
        onSelectionChange={handleBeDeliveryManApp}
        typeCity={1}
      />
      <SelectStateAndCityV2
        isOpen={openModalPartnerShop}
        onClose={() => setOpenModalPartnerShop(false)}
        onSelectionChange={handlePartnerShop}
        typeCity={1}
      />
    </Container>
  );
};

export default User;
